import QaGroup from "../../model/guideline/qaData";
import GuidelineData from "../../model/guideline/guidelineData";
import { Api, MethodType, RequestType, ResponseType } from "../define";

// リクエスト
export type Request = RequestType & {
}

// レスポンス
export type Response = ResponseType & {
    qaGroupInfo: QaGroup[],
    guidelineInfo: GuidelineData,
}

export default class GuidelinePageQaApi extends Api<Request, Response>{
    // リクエストURL
    public url = `${process.env.REACT_APP_URL}/webSite/GuidelinePageInfo`;

    // リクエストパラメータ
    public request: Request;

    // コンストラクター
    constructor(request: Request) {
        super(request);
        this.request = request;
        this.method = MethodType.POST;
    }

    // レスポンスパース処理
    public parseResponse(data: any): Response {
        return data;
    }
}